namespace TabAurous.OMS {
    export namespace DiscountingPolicyDetailsService {
        export const baseUrl = 'OMS/DiscountingPolicyDetails';

        export declare function Create(request: Serenity.SaveRequest<DiscountingPolicyDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DiscountingPolicyDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DiscountingPolicyDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DiscountingPolicyDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/DiscountingPolicyDetails/Create",
            Update = "OMS/DiscountingPolicyDetails/Update",
            Delete = "OMS/DiscountingPolicyDetails/Delete",
            Retrieve = "OMS/DiscountingPolicyDetails/Retrieve",
            List = "OMS/DiscountingPolicyDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>DiscountingPolicyDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
